import { useState } from "react";
import { Button, Form, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { ReminderModalData } from "../../../../Data/Messenger/Messenger";
import { NotesModalType } from "../../../../Types/MessengerType";

const ReminderModal: React.FC<NotesModalType> = ({ toggle, modal }) => {
  const [reminderModal, setReminderModal] = useState(1);
  return (
    <Modal className="reminder-modal-main add-popup" isOpen={modal} toggle={toggle}>
      <ModalHeader className="rounded-0">Set redminders
        <Button className="close" onClick={toggle}><span>×</span></Button>
      </ModalHeader>
      <ModalBody className="rounded-0">
        <Form className="default-form">
          <Label>Reminder for (Groups or contacts)</Label>
          <div className="form-group">
            <Input type="text" placeholder="contact or channel" />
          </div>
          <Label>Remind about</Label>
          <div className="form-group">
            <Input type="textarea" className="dib" rows={3} placeholder="Some details about task" />
          </div>
          <Label>Remind about</Label>
          <div className="form-group">
            <ul className="reminder-count">
              {ReminderModalData.map((item, index) => (
                <li className={`${reminderModal === index + 1 ? "active" : ""}`} key={index} onClick={() => setReminderModal(index + 1)}>
                  <div className="reminder-box">
                    <h3 className="remi-num">{item.number}</h3>
                    <h5 className="remi-val">{item.text}</h5>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="form-group mb-0">
            <Label>select custom time</Label>
            <div className="custom-remider-main">
              <div className="custom-remider-content">
                <div className="custom-reminder-inline mb-3">
                  <Input type="date" />
                  <Input type="time" />
                </div>
                <div className="custom-reminder-block">
                  <Input type="select">
                    <option>Do not repeat</option>
                    <option>Weekdays (Mon-Fri)</option>
                    <option>Daily</option>
                    <option>Weekly (Custom)</option>
                  </Input>
                </div>
              </div>
            </div>
          </div>
          <div className="reminder-btn mb-3">
            <Button color="primary" className="button-effect" onClick={toggle}>set reminder</Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default ReminderModal;
